import { useState } from 'react';
import { comments } from '@/mocks/heiLiao';

function likeCount(n: string): number {
  const v = parseFloat(n);
  if (n.includes('万')) return v * 10000;
  return v;
}

export default function CommentWall() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [expanded, setExpanded] = useState(false);
  const shown = expanded ? comments : comments.slice(0, 3);

  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-6 md:px-6">
      <div className="overflow-hidden rounded-2xl border border-background-200/70 bg-background-100/40">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-200/60 bg-background-50 px-4 py-3.5 md:px-5">
          <div className="flex items-center gap-2.5">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-secondary-800 text-background-50">
              <i className="ri-chat-3-fill text-base"></i>
            </span>
            <div>
              <h2 className="font-heading text-lg leading-tight text-foreground-950">网友热议 · 最新热议风向</h2>
              <p className="text-[11px] text-foreground-500">理性吃瓜区 · 留言不代表本站观点</p>
            </div>
          </div>
          <span className="flex items-center gap-1.5 text-[11px] text-foreground-500">
            <i className="ri-shield-check-line text-[12px] text-accent-600"></i> 已开启弹幕礼仪提示
          </span>
        </div>

        <div className="space-y-2.5 p-3 md:p-4">
          {shown.map((c) => (
            <div key={c.id} className="rounded-xl border border-background-200/60 bg-background-50 p-3.5 transition-colors hover:border-background-300/70">
              <div className="flex flex-wrap items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-background-200 text-foreground-700">
                  <i className="ri-user-smile-line text-sm"></i>
                </span>
                <span className="text-[12px] font-semibold text-foreground-900">{c.user}</span>
                <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] font-medium text-secondary-800">{c.vote}</span>
                <span className="ml-auto text-[11px] text-foreground-400">{c.time}</span>
              </div>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-700">{c.text}</p>
              <div className="mt-2 flex items-center gap-4">
                <button
                  onClick={() => setLiked((p) => ({ ...p, [c.id]: !p[c.id] }))}
                  className={`flex items-center gap-1 text-[11px] transition-colors ${liked[c.id] ? 'text-primary-500' : 'text-foreground-400 hover:text-primary-500'}`}
                >
                  <i className={liked[c.id] ? 'ri-thumb-up-fill text-[13px]' : 'ri-thumb-up-line text-[13px]'}></i>
                  {liked[c.id] ? '已赞' : '赞'} {liked[c.id] ? likeCount(c.agree) + 1 : c.agree}
                </button>
                <button className="flex items-center gap-1 text-[11px] text-foreground-400 transition-colors hover:text-primary-500">
                  <i className="ri-reply-line text-[13px]"></i> 回复
                </button>
              </div>
            </div>
          ))}

          <div className="flex justify-center pt-1">
            <button
              onClick={() => setExpanded((v) => !v)}
              className="flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300/70 bg-background-50 px-4 py-1.5 text-[12px] text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              {expanded ? '收起热议' : '查看全部热议'}
              <i className={expanded ? 'ri-arrow-up-s-line text-[13px]' : 'ri-arrow-down-s-line text-[13px]'}></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}